<h2 mat-dialog-title>{{strategy.title}}</h2>
<mat-dialog-content>
    <div *ngIf="alert" class="alert">
        <div>{{alert}}</div>
    </div>
    <div>{{strategy.message}}</div>
    <br>
    <br>
    <input type="file" (change)="fileSelected($event.target.files)" [disabled]="!canUpload">
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-button color="primary" (click)="ok()" [disabled]="!selectedFile || !canUpload">UPLOAD</button>
    <button mat-button color="primary" matDialogClose>CANCEL</button>
</mat-dialog-actions>
